import { render, staticRenderFns } from "./view-buttons.vue?vue&type=template&id=1b507909&"
import script from "./view-buttons.vue?vue&type=script&lang=js&"
export * from "./view-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/view-buttons/view-buttons.vue
// module id = 923
// module chunks = 0